import {configureStore} from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import assigneesReducer from "./features/assigneesSlice";
import authReducer from "./features/authSlice";
import incidentDetailReducer from "./features/incidentDetailSlice";
import incidentDetectionReducer from "./features/incidentDetectionSlice";
import incidentOverviewReducer from "./features/incidentOverviewSlice";
import incidentResponseReducer from "./features/incidentResponseSlice";
import incidentSettingsReducer from "./features/incidentSettingsSlice";
import incidentsReducer from "./features/incidentsSlice";
import investigationReducer from "./features/investigationSlice";
import mitreReducer from "./features/mitreSlice";
import notificationReducer from "./features/notificationsSlice";
import savedInvestigationsReducer from "./features/savedInvestigationsSlice";
import systemStatusReducer from "./features/systemStatusSlice";
import userReducer from "./features/usersSlice";
import {rootSaga} from "./sagas";

const initialiseSagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    assignees: assigneesReducer,
    auth: authReducer,
    incidentDetail: incidentDetailReducer,
    incidentDetection: incidentDetectionReducer,
    incidentOverview: incidentOverviewReducer,
    incidentResponse: incidentResponseReducer,
    incidentSettings: incidentSettingsReducer,
    incidents: incidentsReducer,
    investigation: investigationReducer,
    mitre: mitreReducer,
    notification: notificationReducer,
    savedInvestigations: savedInvestigationsReducer,
    systemStatus: systemStatusReducer,
    users: userReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend([initialiseSagaMiddleware])
});

initialiseSagaMiddleware.run(rootSaga);

export default store;
